import { combineReducers } from "@reduxjs/toolkit";
import patientContext from "../../patient/state/patient-slice";
import patientRecordLockingContext from "../../patient/state/patient-record-locking-slice";
import userContext from "../../security/state/user-slice";
import adminUserContext from "../../admin/state/users/admin-slice";
import adminRoleContext from "../../admin/state/admin-roles-slice";
import implementationSpecialistClientsContext from "../../implementation-specialist/state/clients/implementation-clients-slice";
import implementationFacilityContext from "../../implementation-specialist/state/facility/implementation-facility-slice";
import adminConfigurationContext from "../../admin-configuration/state/admin-configuration-slice";
import vobContext from "../../admissions-advisor/state/vob-slice";
import vobPatientContext from "../../admissions-advisor/state/vob-patient-slice";
import estimatorContext from "../../admissions-advisor/state/estimator-slice";
import riskAssessmentContext from "../../admissions-advisor/state/risk-assessment-slice";
import metaData from "../../meta-data/state/meta-data-slice"
import estimatorContextTop from "./estimator-slice";
import vobContextTop from "./vob-slice";
import riskAssessmentContextTop from "./risk-assessment-slice";
import paymentContext from "../../payment-hub/state/payment-context-slice";

const adminReducer = combineReducers({
  adminRoleContext: adminRoleContext,
  adminConfigurationContext: adminConfigurationContext,
  adminUserContext: adminUserContext,
});

const implementationReducer = combineReducers({
  implementationSpecialistClient: implementationSpecialistClientsContext,
  implementationFacility: implementationFacilityContext,
});

const admissionsAdvisorReducer = combineReducers({
  vobContext: vobContext,
  vobPatientContext: vobPatientContext,
  estimatorContext: estimatorContext,
  riskAssessmentContext: riskAssessmentContext,
});

const rootReducer = combineReducers({
  patientContext: patientContext,
  patientRecordLockingContext: patientRecordLockingContext,
  userContext: userContext,
  adminContext: adminReducer,
  implementationContext: implementationReducer,
  admissionsAdvisorContext: admissionsAdvisorReducer,
  estimatorContext: estimatorContextTop,
  vobContext: vobContextTop,
  riskAssessmentContext: riskAssessmentContextTop,
  metaData: metaData,
  paymentContext: paymentContext,
});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
